import { getPostalVerificationCopy } from './postalVerificationCopy'
export default function RegistrationEmailChoice({personal,onChange,disabled=false,lang='fr',native=false}) {
  if (native) return null
  const copy=getPostalVerificationCopy(lang)
  return <div style={{display:'flex',flexDirection:'column',gap:8}}>
    <button type="button" disabled={disabled} onClick={()=>onChange(!personal)} aria-pressed={personal}
      style={{alignSelf:'flex-start',padding:0,border:0,background:'transparent',color:'#185FA5',fontSize:13,fontWeight:700,textDecoration:'underline',cursor:disabled?'default':'pointer'}}>
      {personal?copy.professionalButton:copy.personalButton}
    </button>
    {personal && <p style={{margin:0,padding:12,border:'1px solid #FDE68A',borderRadius:10,background:'#FFFBEB',color:'#92400E',fontSize:12,lineHeight:1.5}}>{copy.personalInfo}</p>}
  </div>
}
